<template lang="pug">
#report-income-statement
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Menu.__Report') }} : {{ $t('Reports.__IncomeStatements') }}
        //- template(v-slot:actions)
        //-     v-btn.my-2.ml-4(rounded dark @click="downloadReport" color="primary") 
        //-         | {{$t('ActionOption.__Export')}}
    v-container
        v-card(color="#fdf1eb", elevation="0")
            v-card-text
                v-form(v-model="formValid", ref="reportform")
                    v-row
                        v-col(cols="12", md="3")
                            DateRangeSelector(v-model="dateRangeSelect")
                            //- v-select(v-model="dateSelect" :items="dateItems" outlined dense solo hide-details)
                        v-col(cols="12", md="3")
                            v-menu(
                                v-model="rangeDateMenu",
                                offset-y,
                                :close-on-content-click="false",
                                :nudge-right="40",
                                transition="scale-transition",
                                min-width="290px"
                            )
                                template(v-slot:activator="{ on }")
                                    v-text-field(
                                        :value="dateRangeText",
                                        clearable,
                                        hide-details,
                                        solo,
                                        dense,
                                        outlined,
                                        readonly,
                                        append-icon="event",
                                        v-on="on",
                                        :placeholder="$t('Placeholder.__DateRange')",
                                        @click:clear="dates = []"
                                    )
                                v-date-picker(
                                    v-model="dates",
                                    @input="rangeDateMenu = dates.length == 2 ? false : true",
                                    range,
                                    :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
                                )
                        v-col
                            v-btn.float-right(rounded, dark, @click="generateReport", color="primary", min-width="112") {{ $t('Reports.__GenerateReport') }}

        v-row(v-if="reportData")
            v-col.text-right.mx-4
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportExcel") 
                    | {{ $t('ActionOption.__Export') }} EXCEL
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportPDF") 
                    | {{ $t('ActionOption.__Export') }} PDF

        .mt-4(v-if="reportData")
            .summary-box.d-md-flex.justify-center
                //- template(v-for="(item, idx) in reportData.summary.groups")
                    .ma-4
                        .label-title {{$t("AccountGroups.__" + item.group)}}
                        .label-total {{getAmountWithCurrency(item.total, currencyCode)}}
                    .minus.ma-4
                        .label-total.mt-5(v-if="idx != reportData.summary.groups.length -1") - 
                        .label-total.mt-5(v-else) =
                .ma-4.d-flex.justify-center
                    .box
                        .label-title {{ $t('AccountGroups.__Income') }}
                        .label-total {{ getAmountWithCurrency(reportData.summary.Income, currencyCode) }}
                    .minus.ml-4
                        .label-total.mt-5 -
                .ma-4.d-flex.justify-center
                    .box
                        .label-title {{ $t('AccountGroups.__OperatingCosts') }}
                        .label-total {{ getAmountWithCurrency(reportData.summary.OperatingCosts, currencyCode) }}
                    .minus.ml-4
                        .label-total.mt-5 -
                .ma-4.d-flex.justify-center
                    .box
                        .label-title {{ $t('AccountGroups.__OperatingExpenses') }}
                        .label-total {{ getAmountWithCurrency(reportData.summary.OperatingExpenses, currencyCode) }}
                    .minus.ml-4
                        .label-total.mt-5 =

                .ma-4.d-flex.justify-center
                    .box
                        .label-title {{ $t('Reports.__NetProfit') }}
                        .label-total {{ getAmountWithCurrency(reportData.summary.netProfit, currencyCode) }}

            .d-flex.justify-center
                v-btn.ma-4(rounded, outlined, @click="changeMode") {{ mode == 'summary' ? $t('Reports.__ShowDetails') : $t('Reports.__ShowSummary') }}

            #report-data.slim-container(style="margin-right: auto; margin-left: auto")
                .summary-content(v-if="mode == 'summary'")
                    v-simple-table.report-table(dense)
                        template(v-slot:default)
                            thead
                                tr
                                    th {{ $t('Reports.__AccountName') }}
                                    th.text-right {{ dates[0] && dates[0] == '1950-01-01' ? 'Beginning' : dates[0] }} ~ {{ dates[1] }}
                            tbody
                                template(v-for="group in accountGroups")
                                    tr
                                        td {{ $t('AccountGroups.__' + group) }}
                                        td.text-right {{ getAmountWithCurrency(reportData.summary[group], currencyCode) }}

                                    tr(v-if="group == 'OperatingCosts'", style="background-color: #fdf1eb")
                                        td 
                                            .name.font-weight-bold {{ $t('Reports.__GrossProfit') }}
                                            .rate {{ $t('Reports.__GrossMargin') }}
                                        td.text-right 
                                            .name.font-weight-bold {{ getAmountWithCurrency(reportData.summary.grossProfit, currencyCode) }}
                                            .rate {{ getRatePercentage(reportData.summary.grossProfitRate) }}%

                                    tr(v-if="group == 'OperatingExpenses'", style="background-color: #fdf1eb")
                                        td 
                                            .name.font-weight-bold {{ $t('Reports.__NetProfit') }}
                                            .rate {{ $t('Reports.__NetProfitMargin') }}
                                        td.text-right 
                                            .name.font-weight-bold {{ getAmountWithCurrency(reportData.summary.netProfit, currencyCode) }}
                                            .rate {{ getRatePercentage(reportData.summary.netProfitRate) }}%
                .details-content(v-else)
                    v-simple-table.report-table(dense)
                        template(v-slot:default)
                            thead
                                tr
                                    th {{ $t('Reports.__AccountName') }}
                                    th.text-right {{ dates[0] == '1950-01-01' ? 'Beginning' : dates[0] }} ~ {{ dates[1] }}
                            tbody
                                template(v-for="group in accountGroups")
                                    tr(style="background-color: #fdf1eb")
                                        td(colspan=2) {{ $t('AccountGroups.__' + group) }}
                                    tr(v-for="account in reportData.detail[group].accounts")
                                        td
                                            router-link(:to="getAccountTransactionUrl(account)", target="_blank")
                                                .primary--text {{ getAccountTranslatedName(account.name) }}
                                        td.text-right {{ getAmountWithCurrency(account.balance, currencyCode) }}
                                    tr
                                        td.font-weight-bold {{ $t('Reports.__Total') }}
                                        td.text-right {{ getAmountWithCurrency(reportData.detail[group].total, currencyCode) }}

                                    tr(v-if="group == 'OperatingCosts'", style="background-color: #fdf1eb")
                                        td 
                                            .name.font-weight-bold {{ $t('Reports.__GrossProfit') }}
                                            .rate {{ $t('Reports.__GrossMargin') }}
                                        td.text-right 
                                            .name.font-weight-bold {{ getAmountWithCurrency(reportData.detail.grossProfit, currencyCode) }}
                                            .rate {{ getRatePercentage(reportData.detail.grossProfitRate) }}%

                                    tr(v-if="group == 'OperatingExpenses'", style="background-color: #fdf1eb")
                                        td 
                                            .name.font-weight-bold {{ $t('Reports.__NetProfit') }}
                                            .rate {{ $t('Reports.__NetProfitMargin') }}
                                        td.text-right 
                                            .name.font-weight-bold {{ getAmountWithCurrency(reportData.detail.netProfit, currencyCode) }}
                                            .rate {{ getRatePercentage(reportData.detail.netProfitRate) }}%

                                    tr.no-hover
                                        td(colspan=2, style="border-bottom: 0px")

            .d-flex.justify-center
                v-btn.ma-4(rounded, outlined, @click="changeMode") {{ mode == 'summary' ? $t('Reports.__ShowDetails') : $t('Reports.__ShowSummary') }}

        .no-data.mt-4.text-center.grey-darken-1--text(v-else) {{ $t('Table.__NoData') }}
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"
import * as AccountHelper from "@/utils/accountHelper"
import * as CurrencyHelper from "@/utils/currencies"
import { saveAs } from "file-saver"
import { Workbook, boldRowText, setCellAlignment } from "@/utils/excelFileHelper"
import * as pdfFileHelper from "@/utils/pdfFileHelper"

export default {
  mixins: [TimeHelper.mixin, AccountHelper.mixin, CurrencyHelper.mixin],

  data() {
    return {
      title: this.$t("Reports.__IncomeStatements"),
      formValid: false,
      mode: "summary",
      dates: [],
      rangeDateMenu: false,
      dateRangeSelect: null,
      accountId: "",
      reportData: null,
      accountGroups: ["Income", "OperatingCosts", "OperatingExpenses"],
      groupTotal: null,
      currencyCode: "TWD"
    }
  },
  computed: {
    dateRangeText() {
      if (this.dates[0] == "1950-01-01") return "Beginning ~ " + this.dates[1]
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    filename() {
      return this.title + "_" + this.dates[0] + "_" + this.dates[1]
    }
  },
  watch: {
    dateRangeSelect(item) {
      if (item.text != this.$t("Reports.__Custom")) {
        this.dates = [item.from, item.to]
      }
    }
  },
  methods: {
    generateReport() {
      this.reportData = null
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("reports/getIncomeStatement", {
          from: this.dates[0],
          to: this.dates[1]
        })
        .then(
          function(response) {
            if (response.data.summary.groups) {
              for (var item of response.data.summary.groups) {
                response.data.summary[item.group] = item.total
              }
            }
            if (response.data.detail.groups) {
              for (var detailItem of response.data.detail.groups) {
                response.data.detail[detailItem.group] = detailItem
              }
            }
            this.reportData = response.data ? response.data : null

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    changeMode() {
      this.mode = this.mode == "summary" ? "details" : "summary"
    },
    getRatePercentage(number) {
      if (number != "--") {
        return parseFloat((number * 100).toFixed(2))
      }
      return number
    },
    downloadReportExcel() {
      var filename = this.filename + ".xlsx"
      const workbook = new Workbook()
      var sheetName = this.title
      var worksheet = workbook.addWorksheet(sheetName)
      worksheet.addRow([this.$store.getters["bizes/biz"]().name])

      // var data = []
      worksheet.addRow([
        this.$t("Reports.__AccountName"),
        this.dates[0] == "1950-01-01" ? "Beginning" : this.dates[0] + "~" + this.dates[1]
      ])

      for (var group of this.accountGroups) {
        boldRowText(worksheet.addRow([this.$t("AccountGroups.__" + group)]))
        for (var account of this.reportData.detail[group].accounts) {
          worksheet.addRow([this.getAccountTranslatedName(account.name), this.getAmountWithCurrency(account.balance)])
        }
        boldRowText(
          worksheet.addRow([this.$t("Reports.__Total"), this.getAmountWithCurrency(this.reportData.detail[group].total)])
        )
        if (group == "OperatingCosts") {
          boldRowText(
            worksheet.addRow([this.$t("Reports.__GrossProfit"), this.getAmountWithCurrency(this.reportData.detail.grossProfit)])
          )
          var grossMarginRow = boldRowText(
            worksheet.addRow([
              this.$t("Reports.__GrossMargin"),
              this.getRatePercentage(this.reportData.detail.grossProfitRate) + "%"
            ])
          )
          setCellAlignment(grossMarginRow, 2, "right")
        } else if (group == "OperatingExpenses") {
          boldRowText(
            worksheet.addRow([this.$t("Reports.__NetProfit"), this.getAmountWithCurrency(this.reportData.detail.netProfit)])
          )
          var netProfitRow = boldRowText(
            worksheet.addRow([
              this.$t("Reports.__NetProfitMargin"),
              this.getRatePercentage(this.reportData.detail.netProfitRate) + "%"
            ])
          )
          setCellAlignment(netProfitRow, 2, "right")
        }
        worksheet.addRow([])
      }
      workbook.download(filename)
    },
    downloadReportPDF() {
      var filename = this.filename + ".pdf"
      var content = []
      content.push(pdfFileHelper.pdfTitle(this.$store.getters["bizes/biz"]().name))
      content.push(pdfFileHelper.pdfHeader(this.title))
      content.push(this.dates[0] + " ~ " + this.dates[1])

      for (var group of this.accountGroups) {
        var tableBody = []
        var tableHeaders = [pdfFileHelper.pdfTableHeader(this.$t("AccountGroups.__" + group), 2, "left"), {}]
        tableBody.push(tableHeaders)
        for (var account of this.reportData.detail[group].accounts) {
          tableBody.push([
            this.getAccountTranslatedName(account.name),
            pdfFileHelper.pdfTableText(this.getAmountWithCurrency(account.balance, this.currencyCode), 1, "right")
          ])
        }
        tableBody.push([
          pdfFileHelper.pdfTableBoldText(this.$t("Reports.__Total")),
          pdfFileHelper.pdfTableBoldText(
            this.getAmountWithCurrency(this.reportData.detail[group].total, this.currencyCode),
            1,
            "right"
          )
        ])
        if (group == "OperatingCosts") {
          tableBody.push([
            pdfFileHelper.pdfTableBoldText(this.$t("Reports.__GrossProfit")),
            pdfFileHelper.pdfTableBoldText(
              this.getAmountWithCurrency(this.reportData.detail.grossProfit, this.currencyCode),
              1,
              "right"
            )
          ])
          tableBody.push([
            pdfFileHelper.pdfTableBoldText(this.$t("Reports.__GrossMargin")),
            pdfFileHelper.pdfTableBoldText(this.getRatePercentage(this.reportData.detail.grossProfitRate) + "%", 1, "right")
          ])
        } else if (group == "OperatingExpenses") {
          tableBody.push([
            pdfFileHelper.pdfTableBoldText(this.$t("Reports.__NetProfit")),
            pdfFileHelper.pdfTableBoldText(
              this.getAmountWithCurrency(this.reportData.detail.netProfit, this.currencyCode),
              1,
              "right"
            )
          ])
          tableBody.push([
            pdfFileHelper.pdfTableBoldText(this.$t("Reports.__NetProfitMargin")),
            pdfFileHelper.pdfTableBoldText(this.getRatePercentage(this.reportData.detail.netProfitRate) + "%", 1, "right")
          ])
        }

        content.push(pdfFileHelper.pdfTableSimple(tableBody))
      }
      content.push("")
      pdfFileHelper.downloadPDF(filename, content)
    },
    // downloadReport() {
    //     if (this.reportData) {
    //         var filename =
    //             this.$t("Reports.__IncomeStatements") +
    //             "_" +
    //             this.dates[0] +
    //             "_" +
    //             this.dates[1]
    //         this.$store.dispatch("global/startLoading")
    //         PDF.download("#report-data", filename, () => {
    //             this.$store.dispatch("global/stopLoading")
    //         })
    //     }
    // },
    getAccountTransactionUrl(account) {
      return (
        "/" +
        this.$route.params.lang +
        "/reports/account-transactions?from=" +
        this.dates[0] +
        "&to=" +
        this.dates[1] +
        "&accountid=" +
        account.id
      )
    }
  },
  mounted() {
    var from = this.$route.query.from
    var to = this.$route.query.to
    if (from != undefined && to != undefined) {
      if (from == "beginning") from = "1950-01-01"
      this.dates = [from, to]
      this.generateReport()
    }
  },
  created() {
    var today = new Date()
    this.dates = [today.getFullYear() + "-01-01", this.getStringByFormat(today)]
    this.generateReport()
    this.currencyCode = this.$store.getters["bizes/currencyCode"]()
  }
}
</script>

<style lang="scss" scoped>
.summary-box {
  .label-title {
    color: #b4b9be;
    font-size: 14px;
  }

  .label-total {
    font-size: 23px;
    color: #1e1e21;
  }
}
.summary-content,
.details-content {
  .rate {
    color: #505356;
    font-size: 13px;
  }
}
a {
  text-decoration: none;
}
</style>
